import { render, staticRenderFns } from "./GClassManagementCompetencyRanking.vue?vue&type=template&id=1cac545b&scoped=true&"
import script from "./GClassManagementCompetencyRanking.vue?vue&type=script&lang=ts&"
export * from "./GClassManagementCompetencyRanking.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cac545b",
  null
  
)

export default component.exports